import api from "./client";

export async function listMoldsPaged({ status, page, limit } = {}) {
  const params = new URLSearchParams();
  if (status) params.set("status", String(status));
  if (page != null) params.set("page", String(page));
  if (limit != null) params.set("limit", String(limit));
  const query = params.toString();
  const res = await api.get(`/molds${query ? `?${query}` : ""}`);
  return res.data.data;
}

export async function createMold(payload) {
  const res = await api.post("/molds", payload);
  return res.data.data;
}

export async function updateMold(id, payload) {
  const res = await api.put(`/molds/${id}`, payload);
  return res.data.data;
}

export async function deleteMold(id) {
  const res = await api.delete(`/molds/${id}`);
  return res.data.data;
}
